module.exports = __webpack_public_path__ + "img/newBook.adedcccf.png";